<template>
  <PageWrapper :isLoading="isLoading">
    <template #title> ویرایش سوال {{ questionTitle }} </template>
    <BRow v-if="questionDetails">
      <BCol cols="12" md="6">
        <QuestionLevelPicker
          :defaultSelectedLevel="questionDetails.questionLevel"
          v-model="questionDetails.questionLevel"
        ></QuestionLevelPicker>
      </BCol>
      <BCol cols="12" md="6">
        <TextInput
          customRules="required|min:1"
          inputId="questionTitle"
          inputLabel="متن سوال را وارد کنید"
          inputPlaceholder="متن سوال"
          v-model="questionDetails.questionText"
        ></TextInput>
      </BCol>
      <BCol cols="12">
        <TextInput
          customRules="required|min:1"
          inputId="periodTime"
          inputLabel="زمان مورد نیاز برای پاسخ به سوال (دقیقه)"
          inputPlaceholder="زمان (دقیقه)"
          v-model.number="questionDetails.periodTime"
        ></TextInput>
      </BCol>
      <BCol cols="12" md="6">
        <TextInput
          customRules="required|min:1"
          inputId="answerA"
          inputLabel="متن گزینه A"
          inputPlaceholder="A"
          v-model="questionDetails.a"
        ></TextInput>
      </BCol>
      <BCol cols="12" md="6">
        <TextInput
          customRules="required|min:1"
          inputId="answerB"
          inputLabel="متن گزینه B"
          inputPlaceholder="B"
          v-model="questionDetails.b"
        ></TextInput>
      </BCol>
      <BCol cols="12" md="6">
        <TextInput
          customRules="required|min:1"
          inputId="answerC"
          inputLabel="متن گزینه C"
          inputPlaceholder="C"
          v-model="questionDetails.c"
        ></TextInput>
      </BCol>
      <BCol cols="12" md="6">
        <TextInput
          customRules="required|min:1"
          inputId="answerD"
          inputLabel="متن گزینه D"
          inputPlaceholder="D"
          v-model="questionDetails.d"
        ></TextInput>
      </BCol>
      <BCol cols="12">
        <p>جواب صحیح را انتخاب کنید</p>
        <div class="d-flex" style="gap: 1.5rem">
          <BFormRadio
            name="correctAnswer"
            class="custom-control-primary"
            value="a"
            v-model="questionDetails.correctAnswer"
          >
            A
          </BFormRadio>
          <BFormRadio
            name="correctAnswer"
            class="custom-control-primary"
            value="b"
            v-model="questionDetails.correctAnswer"
          >
            B
          </BFormRadio>
          <BFormRadio
            name="correctAnswer"
            class="custom-control-primary"
            value="c"
            v-model="questionDetails.correctAnswer"
          >
            C
          </BFormRadio>
          <BFormRadio
            name="correctAnswer"
            class="custom-control-primary"
            value="d"
            v-model="questionDetails.correctAnswer"
          >
            D
          </BFormRadio>
        </div>
      </BCol>
      <BCol cols="auto" class="ml-auto">
        <BButton @click="updateAQuestion" variant="primary"> ثبت </BButton>
      </BCol>
    </BRow>
  </PageWrapper>
</template>

<script>
export default {
  data() {
    return {
      questionDetails: null,
      isDescriptive: false,
      isLoading: false,
      questionLevelEnums: [
        {
          text: "آسان",
          value: 1,
        },
        {
          text: "معمولی",
          value: 2,
        },
        {
          text: "سخت",
          value: 3,
        },
        {
          text: "خیلی سخت",
          value: 4,
        },
      ],
    };
  },
  mounted() {
    this.getASingleQuestion();
  },
  methods: {
    async getASingleQuestion() {
      this.isLoading = true;
      let _this = this;
      let getAQuestion = new GetAQuestion(_this);
      getAQuestion.setRequestParam({
        id: _this.$route.params.id,
      });
      await getAQuestion.fetch(
        function (response) {
          if (response.isSuccess) {
            _this.questionDetails = response.data;
          }
        },
        function (error) {
          console.error(error);
        }
      );
      this.isLoading = false;
    },
    async updateAQuestion() {
      let _this = this;
      let updateQuestion = new UpdateQuestion(_this);
      updateQuestion.setParams(_this.questionDetails);
      await updateQuestion.fetch(
        function (response) {
          _this.getASingleQuestion();
          _this.$toast({
            component: ToastificationContent,
            props: {
              title: "ویرایش با موفقیت انجام شد",
              icon: "EditIcon",
              variant: "success",
            },
          });
        },
        function (error) {
          console.error(error);
        }
      );
    },
  },
  computed: {
    questionTitle() {
      if (this.questionDetails && this.questionDetails.questionText) {
        return this.questionDetails.questionText;
      }
      return "";
    },
  },
  components: {
    PageWrapper,
    TextInput,
    CoursePicker,
    LessonPicker,
    QuestionLevelPicker,
    BRow,
    BCol,
    BFormRadio,
    BButton,
  },
};
import { BRow, BCol, BFormRadio, BButton } from "bootstrap-vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import TextInput from "@/views/components/Utils/TextInput.vue";
import PageWrapper from "@/views/components/Utils/PageWrapper.vue";
import LessonPicker from "@/views/components/Lessons/LessonPicker.vue";
import CoursePicker from "@/views/components/MasterActiveCourse/CoursePicker.vue";
import QuestionLevelPicker from "@/views/components/Questions/QuestionLevelPicker.vue";
import { GetAQuestion, UpdateQuestion } from "@/libs/Api/Question";
</script>
